// AUTO-GENERATED — DO NOT EDIT THIS FILE DIRECTLY.
//
// Synced from wallet-rbac/RequireCapability.jsx
// by scripts/sync_wallet_app.sh on 2026-07-17T08:09:17Z.
//
// To make changes:
//   1. Edit react/_shared/wallet-app/wallet-rbac/RequireCapability.jsx
//   2. Run ./scripts/sync_wallet_app.sh
//
// Editing this copy in place will be overwritten on next sync.
//
// ---------------------------------------------------------------

// wallet-rbac/RequireCapability.jsx
//
// Capability guard component. Hides its children if the current role lacks
// the capability; optionally shows a fallback (default: an inline warning
// chip explaining why the action is disabled).

import React from 'react';
import { Alert } from '@mui/material';
import { useRole } from './RoleContext';

const DEFAULT_FALLBACK = (cap) => (
  <Alert severity="info" sx={{ my: 1 }}>
    This action ({cap}) is not available to your role. Contact your team
    admin to upgrade your capability.
  </Alert>
);

export function RequireCapability({ cap, children, fallback }) {
  const { hasCapability } = useRole();
  if (!cap) return children;
  if (hasCapability(cap)) return children;
  if (fallback !== undefined) return fallback;
  return DEFAULT_FALLBACK(cap);
}

export default RequireCapability;
